import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useTranslation } from "react-i18next";
import { ColorPicker } from "primereact/colorpicker";
import dbservice from "../../Utility/DbConnection/dbservice";
import { Toast } from "primereact/toast";
import { FilterMatchMode } from "primereact/api";
import { Dropdown } from "primereact/dropdown";

function EventsMetadataDialog({
  measuresMetadata,
  setMeasuresData,
  visible,
  onHide,
}) {
  const { t } = useTranslation();
  const toast = useRef(null);
  const [machineOptions, setMachineOptions] = useState([]);
  const [eventOptions, setEventOptions] = useState([]);
  const [filters, setFilters] = useState({
    Machine: { value: null, matchMode: FilterMatchMode.EQUALS },
    EventName: { value: null, matchMode: FilterMatchMode.EQUALS },
    MeasureName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    EnDescr: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  useEffect(() => {
    if (visible & (measuresMetadata != null) && measuresMetadata.length > 0) {
      console.log("event data", measuresMetadata);
      const machineOptions = [
        ...new Set(measuresMetadata.map((item) => item.Machine)),
      ].map((machine) => ({ label: machine, value: machine }));
      setMachineOptions(machineOptions);
      const eventOptions = [
        ...new Set(measuresMetadata.map((item) => item.EventName)),
      ].map((event) => ({ label: event, value: event }));
      setEventOptions(eventOptions);
    }
  }, [visible]);

  const machineFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={machineOptions}
        onChange={(e) => {
          options.filterCallback(e.value, options.index);
          const newFilters = { ...filters };
          newFilters.Machine.value = e.value;
          setFilters(newFilters);
        }}
        className="p-column-filter"
        showClear
        filter
      />
    );
  };
  const eventFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={eventOptions}
        onChange={(e) => {
          options.filterCallback(e.value, options.index);
          const newFilters = { ...filters };
          newFilters.EventName.value = e.value;
          setFilters(newFilters);
        }}
        className="p-column-filter"
        showClear
        filter
      />
    );
  };

  return (
    <Dialog
      header={
        <div
          style={{ display: "flex", alignItems: "center" }}
        >
          <i className="pi pi-cog" style={{ marginRight: "0.5rem" }}></i>
          {t("measuresDetails")}
        </div>
      }
      visible={visible}
      onHide={onHide}
      style={{ width: "90%" }}
    >
      <Toast ref={toast} />
      <DataTable
        value={measuresMetadata}
        stripedRows
        paginator
        rows={10}
       
        filters={filters}
        onFilter={(e) => {
          setFilters(e.filters);
        }}
      >
        <Column
          field="Machine"
          header={t("machine")}
          sortable
          filter
          filterElement={machineFilterTemplate}
          showFilterMenu={false}
          filterMatchMode="equals" // ✅ Fix: explicitly define match mode
        />
        <Column
          field="EventName"
          header={t("eventName")}
          sortable
          filter
          filterElement={eventFilterTemplate}
          showFilterMenu={false}
          filterMatchMode="equals" // ✅ Fix: explicitly define match mode
        ></Column>

        <Column
          field="MeasureName"
          header={t("measurename")}
          sortable
          filter

        ></Column>
        <Column
          field="EnDescr"
          header={t("description")}
          sortable
          filter
        ></Column>

        {/*<Column field="Conversion" header={t("scaling")} sortable></Column>*/}
      </DataTable>
    </Dialog>
  );
}

export default EventsMetadataDialog;
